import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { paths } from '@app/constants';
import { LoginView, RefreshBody } from '@data/sdk/match';
import { MatchingApi } from '@data/utils/axios-instance';

export const useRefreshTeam = (
  withToken: boolean,
): UseMutationResult<LoginView, Error, RefreshBody, unknown> => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async (values) => {
      const response = await MatchingApi.auth.refresh({ refreshBody: values });
      return response.data;
    },
    onSuccess: () =>
      navigate(
        withToken
          ? `/${paths.app}/${paths.trial_recruitment}/${paths.trials}`
          : `/${paths.app}/${paths.onboarding.root}`,
      ),
  });
};
